export const initialAdverseEventState = {
    adverse_event: {
        id: null,
        patient_id: null,
        event_type: null,
        event_date: null,
        blood_result_id: null,
        send_notifications: null,
        reporting_type: null,
        created_at: null,
        updated_at: null,
        pdf_data: {
            id: null,
            created_at: null,
            updated_at: null,
            patient_memo_id: null,
            reporter_name: null,
            reporter_address: null,
            reporter_type: null,
            patient_initials: null,
            patient_dob: null,
            patient_gender: null,
            patient_dms_id: null,
            patient_age: null,
            company_product: null,
            company_product_taken: false,
            company_suspected_as_possible_cause_of_events: false,
            company_indication_diagnosis: null,
            company_dose_route: null,
            company_start_date: null,
            company_stop_date: null,
            safety_off_label_indication: false,
            safety_drug_indication: false,
            safety_exposure_during_pregnancy: false,
            safety_lack_of_efficacy: false,
            safety_misuse_abuse: false,
            safety_medication_prescription_error: false,
            safety_overdose: false,
            other_products: null,
            adverse_event_date_event_started: null,
            adverse_event_date_event_stopped: null,
            adverse_event_continuing: false,
            adverse_event_seriousness: false,
            adverse_event_seriousness_criteria: null,
            adverse_event_treatment_required: null,
            description_decreased_white_blood_cell_count_of: null,
            description_decreased_white_blood_cell_count_of_value: null,
            description_decreased_neutrophil_count_of: null,
            description_decreased_neutrophil_count_of_value: null,
            description_decreased_platelets_count_of: null,
            description_decreased_platelets_count_of_value: null,
            description_summary: null,
            details_date_received: null,
            details_date_processed: null,
            details_signature: null,
            details_date: null,
        },
    },
    errorMessages: {
        adverse_event: {
            id: [],
            patient_id: [],
            event_type: [],
            event_date: [],
            blood_result_id: [],
            send_notifications: [],
            reporting_type: [],
            created_at: [],
            updated_at: [],
            pdf_data: {
                id: [],
                created_at: [],
                updated_at: [],
                patient_memo_id: [],
                reporter_name: [],
                reporter_address: [],
                reporter_type: [],
                patient_initials: [],
                patient_dob: [],
                patient_gender: [],
                patient_dms_id: [],
                patient_age: [],
                company_product: [],
                company_product_taken: [],
                company_suspected_as_possible_cause_of_events: [],
                company_indication_diagnosis: [],
                company_dose_route: [],
                company_start_date: [],
                company_stop_date: [],
                safety_off_label_indication: [],
                safety_drug_indication: [],
                safety_exposure_during_pregnancy: [],
                safety_lack_of_efficacy: [],
                safety_misuse_abuse: [],
                safety_medication_prescription_error: [],
                safety_overdose: [],
                other_products: [],
                adverse_event_date_event_started: [],
                adverse_event_date_event_stopped: [],
                adverse_event_continuing: [],
                adverse_event_seriousness: [],
                adverse_event_seriousness_criteria: [],
                adverse_event_treatment_required: [],
                description_decreased_white_blood_cell_count_of: [],
                description_decreased_white_blood_cell_count_of_value: [],
                description_decreased_neutrophil_count_of: [],
                description_decreased_neutrophil_count_of_value: [],
                description_summary: [],
                details_date_received: [],
                details_date_processed: [],
                details_signature: [],
                details_date: [],
            },
        },
    },
};
const AdverseEvent = {
    namespaced: true,
    state: {
        adverse_event: initialAdverseEventState.adverse_event,
        errorMessages: initialAdverseEventState.errorMessages,
    },
    mutations: {
        SET_ADVERSE_EVENT_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
            // state.patient[data.property] = data.value;
        },
        RESET_ADVERSE_EVENT_PROPERTY_ERROR(state, data) {
            _.set(state.errorMessages, data.property, data.value);
        },
        SET_ADVERSE_EVENT(state, data) {
            state.adverse_event = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // state.errorMessages[data.property] = data.value;
            // _.set(state, data.property, data.value);
        },
        RESET_ADVERSE_EVENT_FORM(state) {
            state.adverse_event = {
                id: null,
                patient_id: null,
                event_type: null,
                event_date: null,
                blood_result_id: null,
                send_notifications: null,
                reporting_type: null,
                created_at: null,
                updated_at: null,
                pdf_data: {
                    id: null,
                    created_at: null,
                    updated_at: null,
                    patient_memo_id: null,
                    reporter_name: null,
                    reporter_address: null,
                    reporter_type: null,
                    patient_initials: null,
                    patient_dob: null,
                    patient_gender: null,
                    patient_dms_id: null,
                    patient_age: null,
                    company_product: null,
                    company_product_taken: false,
                    company_suspected_as_possible_cause_of_events: false,
                    company_indication_diagnosis: null,
                    company_dose_route: null,
                    company_start_date: null,
                    company_stop_date: null,
                    safety_off_label_indication: false,
                    safety_drug_indication: false,
                    safety_exposure_during_pregnancy: false,
                    safety_lack_of_efficacy: false,
                    safety_misuse_abuse: false,
                    safety_medication_prescription_error: false,
                    safety_overdose: false,
                    other_products: null,
                    adverse_event_date_event_started: null,
                    adverse_event_date_event_stopped: null,
                    adverse_event_continuing: false,
                    adverse_event_seriousness: false,
                    adverse_event_seriousness_criteria: null,
                    adverse_event_treatment_required: null,
                    description_decreased_white_blood_cell_count_of: null,
                    description_decreased_white_blood_cell_count_of_value: null,
                    description_decreased_neutrophil_count_of: null,
                    description_decreased_neutrophil_count_of_value: null,
                    description_summary: null,
                    details_date_received: null,
                    details_date_processed: null,
                    details_signature: null,
                    details_date: null,
                },
            };
        },
        RESET_ERROR_MESSAGES(state) {
            state.errorMessages = {
                adverse_event: {
                    id: [],
                    patient_id: [],
                    event_type: [],
                    event_date: [],
                    blood_result_id: [],
                    send_notifications: [],
                    reporting_type: [],
                    created_at: [],
                    updated_at: [],
                    pdf_data: {
                        id: [],
                        created_at: [],
                        updated_at: [],
                        patient_memo_id: [],
                        reporter_name: [],
                        reporter_address: [],
                        reporter_type: [],
                        patient_initials: [],
                        patient_dob: [],
                        patient_gender: [],
                        patient_dms_id: [],
                        patient_age: [],
                        company_product: [],
                        company_product_taken: [],
                        company_suspected_as_possible_cause_of_events: [],
                        company_indication_diagnosis: [],
                        company_dose_route: [],
                        company_start_date: [],
                        company_stop_date: [],
                        safety_off_label_indication: [],
                        safety_drug_indication: [],
                        safety_exposure_during_pregnancy: [],
                        safety_lack_of_efficacy: [],
                        safety_misuse_abuse: [],
                        safety_medication_prescription_error: [],
                        safety_overdose: [],
                        other_products: [],
                        adverse_event_date_event_started: [],
                        adverse_event_date_event_stopped: [],
                        adverse_event_continuing: [],
                        adverse_event_seriousness: [],
                        adverse_event_seriousness_criteria: [],
                        adverse_event_treatment_required: [],
                        description_decreased_white_blood_cell_count_of: [],
                        description_decreased_white_blood_cell_count_of_value: [],
                        description_decreased_neutrophil_count_of: [],
                        description_decreased_neutrophil_count_of_value: [],
                        description_summary: [],
                        details_date_received: [],
                        details_date_processed: [],
                        details_signature: [],
                        details_date: [],
                    },
                },
            };
        },
    },
    actions: {
        updateProperty({ commit }, data) {
            commit('SET_ADVERSE_EVENT_PROPERTY', data);
        },
        resetAdverseEvent({ commit }) {
            const event = _.clone(initialAdverseEventState.adverse_event);
            _.set(event, 'id', null);
            commit('SET_ADVERSE_EVENT', event);
        },
        loadAdverseEvent({ commit, dispatch }, data) {
            dispatch('resetErrorMessages');
            return axios
                .get(
                    route('api.v1.patients.adverse-events.show', {
                        patient: data.patient_id,
                        adverse_event: data.id,
                        fields: '*,pdf_data',
                    })
                )
                .then((response) => {
                    const data = _.clone(response.data.data);
                    if (data && data.pdf_data) {
                        const event = _.clone(data);
                        if (!event.id) {
                            _.set(event, 'id', 'new');
                        }
                        commit('SET_ADVERSE_EVENT', event);
                    }
                });
        },
        newAdverseEvent({ commit }, data) {
            commit('SET_ADVERSE_EVENT', {
                id: null,
            });
            _.delay(() => {
                const event = _.clone(initialAdverseEventState.adverse_event);
                _.set(event, 'id', 'new');
                _.set(event, 'blood_result_id', data.id);
                commit('SET_ADVERSE_EVENT', event);
            }, 300);
        },
        setPharmacySite({ commit }, data) {
            commit('SET_HAS_PHARMACY_SITE', true);
            commit('SET_ADVERSE_EVENT_PROPERTY', { property: 'patient.pharmacy_site_id', value: data.value });
        },
        resetPropertyError({ commit }, data) {
            commit('RESET_ADVERSE_EVENT_PROPERTY_ERROR', data);
        },
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        resetForm({ commit }) {
            commit('RESET_ADVERSE_EVENT_FORM');
        },
        resetErrorMessages({ commit }) {
            commit('RESET_ERROR_MESSAGES');
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.adverse_event, fieldErrors.field);
                if (fieldErrors.field && errorMessageField !== undefined) {
                    const reg = new RegExp('(?=(data.*) (?<=)(field))');
                    const errors = new Array();
                    fieldErrors.errors.forEach((error) => {
                        const isMatch = error.match(reg);
                        if (isMatch) {
                            const value = error.replace(
                                isMatch[1],
                                t(`patients::adverse_event.form.validation.${fieldErrors.field}`)
                            );
                            return errors.push(value);
                        }
                        return errors.push(error);
                    });
                    return commit('SET_ERROR_MESSAGE', {
                        value: errors,
                        property: 'adverse_event.' + fieldErrors.field,
                    });
                }
            });
        },
    },
};
export default AdverseEvent;
